import { IconProps } from "@cobasi/ds-icons";

import A from "@cobasi/ds-icons/solid/a";
import B from "@cobasi/ds-icons/solid/b";
import C from "@cobasi/ds-icons/solid/c";
import D from "@cobasi/ds-icons/solid/d";
import E from "@cobasi/ds-icons/solid/e";
import F from "@cobasi/ds-icons/solid/f";
import G from "@cobasi/ds-icons/solid/g";
import H from "@cobasi/ds-icons/solid/h";
import I from "@cobasi/ds-icons/solid/i";
import J from "@cobasi/ds-icons/solid/j";
import K from "@cobasi/ds-icons/solid/k";
import L from "@cobasi/ds-icons/solid/l";
import M from "@cobasi/ds-icons/solid/m";
import N from "@cobasi/ds-icons/solid/n";
import O from "@cobasi/ds-icons/solid/o";
import P from "@cobasi/ds-icons/solid/p";
import Q from "@cobasi/ds-icons/solid/q";
import R from "@cobasi/ds-icons/solid/r";
import S from "@cobasi/ds-icons/solid/s";
import T from "@cobasi/ds-icons/solid/t";
import U from "@cobasi/ds-icons/solid/u";
import V from "@cobasi/ds-icons/solid/v";
import W from "@cobasi/ds-icons/solid/w";
import X from "@cobasi/ds-icons/solid/x";
import Y from "@cobasi/ds-icons/solid/y";
import Z from "@cobasi/ds-icons/solid/z";

export const alphabet: {
  letter:
    | "a"
    | "b"
    | "c"
    | "d"
    | "e"
    | "f"
    | "g"
    | "h"
    | "i"
    | "j"
    | "k"
    | "l"
    | "m"
    | "n"
    | "o"
    | "p"
    | "q"
    | "r"
    | "s"
    | "t"
    | "u"
    | "v"
    | "w"
    | "x"
    | "y"
    | "z";
  icon: IconProps["icon"];
}[] = [
  {
    letter: "a",
    icon: A
  },
  {
    letter: "b",
    icon: B
  },
  {
    letter: "c",
    icon: C
  },
  {
    letter: "d",
    icon: D
  },
  {
    letter: "e",
    icon: E
  },
  {
    letter: "f",
    icon: F
  },
  {
    letter: "g",
    icon: G
  },
  {
    letter: "h",
    icon: H
  },
  {
    letter: "i",
    icon: I
  },
  {
    letter: "j",
    icon: J
  },
  {
    letter: "k",
    icon: K
  },
  {
    letter: "l",
    icon: L
  },
  {
    letter: "m",
    icon: M
  },
  {
    letter: "n",
    icon: N
  },
  {
    letter: "o",
    icon: O
  },
  {
    letter: "p",
    icon: P
  },
  {
    letter: "q",
    icon: Q
  },
  {
    letter: "r",
    icon: R
  },
  {
    letter: "s",
    icon: S
  },
  {
    letter: "t",
    icon: T
  },
  {
    letter: "u",
    icon: U
  },
  {
    letter: "v",
    icon: V
  },
  {
    letter: "w",
    icon: W
  },
  {
    letter: "x",
    icon: X
  },
  {
    letter: "y",
    icon: Y
  },
  {
    letter: "z",
    icon: Z
  }
];
